function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import TextField from "../TextField";
import MenuItem from "../MenuItem";
export const Select = _ref => {
  let {
    options,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(TextField, _extends({
    select: true
  }, rest), options.map(_ref2 => {
    let {
      value,
      label
    } = _ref2;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: value,
      value: value
    }, label || value);
  }));
};
export default Select;